const styles = `
    p {
        font-size: 10px !important;
        line-height: 14px !important;
        color: #B2B2B2 !important;
        font-family: "Inter" !important;
    }

    & > div > div > div {
        height: 4px !important;
    }
`;

export default styles;
